/* Home 2609 – Supply Diagram
   Same motion as the mock: when 40% of the diagram is on screen, the routes grow from the left (CSS does the timing),
   then the end points and prices appear. It plays once.
   Reduced motion, or no IntersectionObserver: the diagram is shown complete from the start (is-armed is never added). */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(fig) {
    if (!fig || fig.h2609Ready) return;
    fig.h2609Ready = true;
    if (REDUCED.matches || !('IntersectionObserver' in window)) return;
    fig.classList.add('is-armed');
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { fig.classList.add('is-in'); obs.disconnect(); }
      });
    }, { threshold: 0.4 });
    io.observe(fig);
  }

  function initAll(scope) {
    var figs = (scope || document).querySelectorAll('[data-h2609-sup-fig]');
    for (var i = 0; i < figs.length; i++) init(figs[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
